import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const page = { marginTop: "80px", marginBottom: "60px" };

const FootageDoctorPrivacy = () => {
  document.title = "Footage Doctor Privacy Policy";

  return (
    <div className="ui text container" style={page}>
      <h1 className="ui header">Footage Doctor Privacy Policy</h1>
      <p>
        <em>Effective 13 September 2026</em>
      </p>

      <p>
        This policy explains how Footage Doctor for macOS, made by Chua Wee Liang
        (DevJo), handles your information. The short version: Footage Doctor does
        not collect, store on any server, share or sell any personal data.
      </p>

      <h3>Data we collect</h3>
      <p>
        None. Footage Doctor has no account, no analytics, no advertising, no
        tracking and no crash reporting of its own. The app has no network
        access, so nothing you check ever leaves your Mac through Footage Doctor.
      </p>

      <h3>Files you open</h3>
      <p>
        Footage Doctor only reads the files and folders you choose to check, by
        dragging them onto the app, using the Open panel, or opening them from
        Finder. It reads media information and decodes a few sample frames to
        look for problems. It never modifies, moves or uploads your media.
      </p>

      <h3>Information stored on your Mac</h3>
      <p>To make the app faster and more useful, Footage Doctor keeps the following locally, inside its own sandboxed storage on your Mac:</p>
      <ul>
        <li>
          <strong>Recent checks:</strong> the names and locations of the files
          and folders you checked, when you checked them, their results, and a
          macOS permission bookmark so you can reopen them. This is limited to
          your 50 most recent checks. You can remove an entry or choose Clear
          History in the app at any time.
        </li>
        <li>
          <strong>Preview thumbnails:</strong> small cached frames so previews
          load quickly. This is stored in your Mac's caches folder and can be
          removed by macOS when space is needed.
        </li>
        <li>
          <strong>Exported reports:</strong> if you export a JSON or CSV report,
          it is saved only where you choose.
        </li>
      </ul>
      <p>Deleting Footage Doctor removes its stored history and caches.</p>

      <h3>Third-party components</h3>
      <p>
        Footage Doctor includes open-source libraries, including MediaInfoLib,
        to read media files. They run entirely on your Mac and do not send
        data anywhere.
      </p>

      <h3>Children</h3>
      <p>
        Footage Doctor is not directed at children and collects no personal
        information from anyone, including children.
      </p>

      <h3>Changes to this policy</h3>
      <p>
        If this policy changes, the updated version will be posted on this page
        with a new effective date.
      </p>

      <h3>Contact</h3>
      <p>
        Questions about this policy? Email{" "}
        <a href="mailto:joabchua@gmail.com?subject=Footage%20Doctor%20privacy">
          joabchua@gmail.com
        </a>
        .
      </p>

      <p>
        <Link to="/footagedoctor">Back to Footage Doctor</Link>
      </p>
    </div>
  );
};

export default FootageDoctorPrivacy;
